import React, {Component, PropTypes} from 'react'
import ReactDOM from 'react-dom'
import {KeyboardSelector} from './keyboard_selector'
import {Dropdown} from './dropdown'
import _ from 'lodash'

export class Select extends Component {
  static propTypes = {
    defaultValue: PropTypes.any,
    options: PropTypes.array,
    onChange: PropTypes.func,
    className: PropTypes.string,
  }

  static defaultProps = {
    onChange: _.noop,
    options: [],
  }

  state = {
    selected: this.getSelected(this.props.defaultValue),
    triggerWidth: 100,
  }

  getValue() {
    return this.state.selected.value
  }

  getSelected(value) {
    return _.find(this.props.options, (option) => _.isEqual(value, option.value))
  }

  componentDidMount() {
    this._mounted = true
  }

  componentWillUnmount() {
    this._mounted = false
  }

  setTriggerWidth() {
    const triggerWidth = ReactDOM.findDOMNode(this._trigger).getBoundingClientRect().width

    if (this._mounted) {
      this.setState({ triggerWidth })
    }
  }

  render() {
    return (
      <Dropdown
        trigger={this.renderTrigger()}
        className='select'
        ref={(r) => this._dropdown = r}
      >
        <KeyboardSelector
          className={this.props.className}
          style={{ width: this.state.triggerWidth }}
          options={this.props.options}
          selected={this.state.selected}
          onSelect={(value) => {
            if (this._mounted) {
              this.setState({ selected: this.getSelected(value) })
              this.props.onChange(value)
              this._dropdown.forceClose()
            }
          }}
        />
      </Dropdown>
    )
  }

  renderTrigger() {
    return (
      <div
        className='select--value input'
        ref={(r) => this._trigger = r}
        onClick={this.setTriggerWidth.bind(this)}
      >
        {this.state.selected ? this.state.selected.content : ''} <i className='icon-arrow-down' />
      </div>
    )
  }
}
